import React, { useEffect, useMemo, useState } from 'react';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';
import TagsInteresseTab from '../components/configuracoes/TagsInteresseTab';
import ComunicadosConfigTab from '../components/configuracoes/ComunicadosConfigTab';
import AgendasConfigTab from '../components/configuracoes/AgendasConfigTab';
import LayoutEntidadeTab from '../components/configuracoes/LayoutEntidadeTab';
import RedesSociaisTab from '../components/configuracoes/RedesSociaisTab';
import EntidadeTab from '../components/configuracoes/EntidadeTab';
import ConexoesTab from '../components/configuracoes/ConexoesTab';
import ContratoTemplateTab from '../components/configuracoes/ContratoTemplateTab';
import AnamneseTab from '../components/configuracoes/AnamneseTab';
import FluxopayConfigTab from '../components/configuracoes/FluxopayConfigTab';
import LeadAutomationTab from '../components/configuracoes/LeadAutomationTab';
import PlanoAssinaturaTab from '../components/configuracoes/PlanoAssinaturaTab';

const permittedTabs = [
    { key: 'entidade',         title: 'Entidade',              icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-2 10v-5a1 1 0 00-1-1h-2a1 1 0 00-1 1v5m4 0H9' },
    { key: 'conexoes',         title: 'Conexões',              icon: 'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1' },
    { key: 'tagsInteresse', clinicalOnly: true,    title: 'Tags de Interesse',     icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z' },
    { key: 'comunicacao', clinicalOnly: true,      title: 'Comunicação',           icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
    { key: 'agendas', clinicalOnly: true,          title: 'Agendas',               icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
    { key: 'layout',           title: 'Layout da Entidade',    icon: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z' },
    { key: 'redesSociais',     title: 'Redes Sociais',         icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
    { key: 'contratoTemplate', title: 'Contrato Template',     icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    { key: 'anamnese', clinicalOnly: true,         title: 'Perguntas de Anamnese', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
    { key: 'planoAssinatura', title: 'Plano e Assinatura', legalOnly: true, icon: 'M3 10h18M7 15h1m4 0h1m-8 5h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
    { key: 'fluxopay',         title: 'Fluxopay',              legalOnly: true, icon: 'M3 10h18M7 15h1m4 0h1m-8 5h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
    {
        key: 'assistente',
        title: 'Assistente',
        icon: 'M12 3v2m6.364.636l-1.414 1.414M21 12h-2M5.05 7.05L3.636 5.636M5 12H3m4.05 6.95l-1.414 1.414M12 19v2m4.95-2.05l1.414 1.414M9 16h6a4 4 0 10-6 0z'
    },
];

const tabComponentMap = {
    entidade:         <EntidadeTab />,
    conexoes:         <ConexoesTab />,
    assistente:       <LeadAutomationTab />,
    tagsInteresse:    <TagsInteresseTab />,
    comunicacao:      <ComunicadosConfigTab />,
    agendas:          <AgendasConfigTab />,
    layout:           <LayoutEntidadeTab />,
    redesSociais:     <RedesSociaisTab />,
    contratoTemplate: <ContratoTemplateTab />,
    anamnese:         <AnamneseTab />,
    planoAssinatura:  <PlanoAssinaturaTab />,
    fluxopay:         <FluxopayConfigTab />,
};

const ConfiguracoesPage = () => {
    const { currentUserRole } = useUserContext();
    const { currentEntidade } = useEntidadeContext();
    const [activeTabKey, setActiveTabKey] = useState(permittedTabs[0].key);
    const activeModules = currentEntidade?.modulos_ativos;
    const hasClinicalModule = !Array.isArray(activeModules) || activeModules.includes('consultorio');
    const visibleTabs = useMemo(() => permittedTabs.filter(tab =>
        (!tab.legalOnly || currentUserRole === 'Representante Legal')
        && (!tab.clinicalOnly || hasClinicalModule)
    ), [currentUserRole, hasClinicalModule]);

    useEffect(() => {
        const activeTabIsVisible = visibleTabs.some(tab => tab.key === activeTabKey);
        if (!activeTabIsVisible) {
            setActiveTabKey('entidade');
        }
    }, [activeTabKey, visibleTabs]);

    return (
        <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                .config-sidebar-btn {
                    width: 100%; display: flex; align-items: center; gap: '10px';
                    padding: 10px 14px; border: none; background: none;
                    border-radius: 8px; cursor: pointer; text-align: left;
                    font-family: 'Inter', 'Segoe UI', sans-serif;
                    font-size: calc(13px * var(--font-scale)) font-weight: 500; color: #6b7280;
                    transition: background 0.15s, color 0.15s;
                    margin-bottom: 2px;
                }
                .config-sidebar-btn:hover {
                    background: #f1f5f9; color: #374151;
                }
                .config-sidebar-btn.active {
                    background: #eff6ff; color: #2563eb; font-weight: 600;
                }
                .config-sidebar-btn.active .config-sidebar-icon {
                    color: #2563eb;
                }
                .config-sidebar-icon {
                    color: #9ca3af; flex-shrink: 0; transition: color 0.15s;
                }
            `}</style>

            {/* ── CABEÇALHO ── */}
            <div style={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                padding: '20px 28px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img
                        src={logoImage}
                        alt="Logo"
                        style={{ height: '44px', width: 'auto', opacity: 0.9 }}
                    />
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#fff' }}>
                            Configurações
                        </h2>
                        <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,0.7)' }}>
                            {currentEntidade?.nome || 'Clínica'}
                        </p>
                    </div>
                </div>
                <div style={{
                    padding: '4px 12px', borderRadius: '999px',
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#fff',
                    border: '1px solid rgba(255,255,255,0.25)',
                }}>
                    {currentUserRole}
                </div>
            </div>

            {/* ── LAYOUT: SIDEBAR + CONTEÚDO ── */}
            <div style={{ display: 'flex', minHeight: 'calc(100vh - 84px)' }}>

                {/* ── SIDEBAR ── */}
                <aside style={{
                    width: '220px', flexShrink: 0,
                    backgroundColor: '#fff',
                    borderRight: '1px solid #e5e7eb',
                    padding: '16px 12px',
                    display: 'flex', flexDirection: 'column', gap: '2px',
                }}>
                    <p style={{
                        fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af',
                        textTransform: 'uppercase', letterSpacing: '0.8px',
                        padding: '0 6px', marginBottom: '8px',
                    }}>
                        Seções
                    </p>

                    {visibleTabs.map(tab => (
                        <button
                            key={tab.key}
                            className={`config-sidebar-btn ${activeTabKey === tab.key ? 'active' : ''}`}
                            onClick={() => setActiveTabKey(tab.key)}
                        >
                            <svg
                                className="config-sidebar-icon"
                                width="16" height="16"
                                fill="none" stroke="currentColor"
                                viewBox="0 0 24 24"
                                style={{ marginRight: '10px', flexShrink: 0 }}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={tab.icon} />
                            </svg>
                            {tab.title}
                        </button>
                    ))}
                </aside>

                {/* ── CONTEÚDO DA ABA ATIVA ── */}
                <main style={{ flex: 1, padding: '24px 28px', minWidth: 0 }}>

                    {/* Breadcrumb / título da seção */}
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '8px',
                        marginBottom: '20px', paddingBottom: '16px',
                        borderBottom: '1px solid #f1f5f9',
                    }}>
                        <div style={{
                            width: '32px', height: '32px', borderRadius: '8px',
                            background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0,
                        }}>
                            <svg width="16" height="16" fill="none" stroke="#2563eb" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d={visibleTabs.find(t => t.key === activeTabKey)?.icon || ''} />
                            </svg>
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#111827' }}>
                                {visibleTabs.find(t => t.key === activeTabKey)?.title}
                            </h3>
                            <p style={{ margin: 0, fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>
                                Configurações › {visibleTabs.find(t => t.key === activeTabKey)?.title}
                            </p>
                        </div>
                    </div>

                    {/* Componente da aba */}
                    <div>
                        {tabComponentMap[activeTabKey] ?? (
                            <div style={{
                                textAlign: 'center', padding: '60px 24px',
                                backgroundColor: '#fff', borderRadius: '12px',
                                border: '1px dashed #e5e7eb',
                            }}>
                                <svg width="40" height="40" fill="none" stroke="#d1d5db" viewBox="0 0 24 24"
                                    style={{ display: 'block', margin: '0 auto 12px' }}>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <p style={{ margin: 0, fontSize: `calc(14px * var(--font-scale))`, color: '#9ca3af' }}>
                                    Seção em desenvolvimento.
                                </p>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default ConfiguracoesPage;
